import React, { useState, useEffect, useRef } from 'react';

const ProjectDescription = ({ description }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setIsOverflowing(contentRef.current.scrollHeight > contentRef.current.clientHeight + 1);
    }
  }, [description]);

  return (
    <div className="project-description-wrapper">
      <div
        ref={contentRef}
        className={`project-description ${expanded ? 'expanded' : ''}`}
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {(isOverflowing || expanded) && (
        <span
          className="read-more-toggle"
          onClick={(e) => {
            e.stopPropagation(); // don't trigger card selection
            setExpanded(prev => !prev);
          }}
        >
          {expanded ? 'Read Less' : 'Read More'}
        </span>
      )}
    </div>
  );
};
export default ProjectDescription;